import { render } from "./TheWebsite.vue?vue&type=template&id=2697a8e6"
import script from "./TheWebsite.vue?vue&type=script&lang=js"
export * from "./TheWebsite.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Projects\\svila\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__